import { render, staticRenderFns } from "./ShareOrderItems.vue?vue&type=template&id=7b81eff0&"
import script from "./ShareOrderItems.vue?vue&type=script&lang=js&"
export * from "./ShareOrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports